// No really! It also allows <Space>, ., 0-9, +
export const onlyDigitsEvent = event => {
  const allow = /^[\d+?]*\.?\+?\s?\d*$/.test(event.key) || event.key === 'Backspace';
  return !allow && event.preventDefault();
};
